import { env } from "configs/EnvironmentConfig";
import fetchV2 from "auth/FetchInterceptorV2";

const allocateShippingUnitService = {};

// List Allocate Shipping Units
allocateShippingUnitService.listAllocateShippingUnit = ({ params }) => {
  const columnFilter = params.columnFilter || {};

  const defaultFields = [
    "id",
    "maker_id",
    "maker_date",
    "record_status",
    "object_type",
    "resource_id",
    "auth_status",
    "transport_id",
    "customer",
    "transport",
  ];

  return fetchV2({
    url: `${env.API_MSP}/customer-transports`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-maker_date",
      keywords: params.keywords || "",
      expand: params.expand || "maker,checker,resource",
      fields: params.fields || defaultFields.join(","),
    },
  });
};

// Allocate Shipping Units Detail
allocateShippingUnitService.allocateShippingUnitDetail = ({
  allocateShippingUnitId,
}) => {
  return fetchV2({
    url: `${env.API_MSP}/customer-transports/${allocateShippingUnitId}`,
    method: "get",
  });
};

// Update Allocate Shipping Units
allocateShippingUnitService.updateAllocateShippingUnit = ({
  allocateShippingUnitId,
  data,
}) => {
  return fetchV2({
    url: `${env.API_MSP}/customer-transports/${allocateShippingUnitId}`,
    method: "put",
    data,
  });
};

// Delete Allocate Shipping Units
allocateShippingUnitService.changeStatusAllocateShippingUnit = ({
  allocateShippingUnitId,
  data
}) => {
  return fetchV2({
    url: `${env.API_MSP}/customer-transports/${allocateShippingUnitId}`,
    data,
    method: "put",
  });
};

// Create Allocate Shipping Units
allocateShippingUnitService.createAllocateShippingUnit = ({ data }) => {
  return fetchV2({
    url: `${env.API_MSP}/customer-transports`,
    method: "post",
    data,
  });
};

export default allocateShippingUnitService;
